import {
  compareWithInitVal,
  fieldDataTypes,
} from '../../../../../../shared/lib/formFieldValidators';
import { compareToStartDate } from '../../../lib/fieldValidators';

export const getValidationRules = ({ initialValue, editMode, entity }) =>
  editMode
    ? [
        {
          required: true,
          message: 'Укажите дату окончания',
          type: 'object',
        },
        {
          validator: compareWithInitVal(initialValue, fieldDataTypes.date),
        },
        { validator: compareToStartDate(entity) },
      ]
    : [{ validator: compareToStartDate(entity) }];
